import { useState } from "react";
import * as Animate from "react-reveal";

const faqs = [
  {
    question: "Who can we pay with Utiva Pay?",
    answer:
      "Utiva Pay is designed for companies managing remote employees, contractors and mixed global teams.",
  },
  {
    question: "Where is Utiva Pay available?",
    answer:
      "Utiva currently supports payroll coordination across more than 12 countries. Share your markets with a specialist to confirm the right setup.",
  },
  {
    question: "Can Utiva help with onboarding?",
    answer:
      "Yes. Utiva can help coordinate worker records, supported engagement options and the information needed before the first payroll cycle.",
  },
  {
    question: "Will workers know what is happening with their payout?",
    answer:
      "Yes. The experience is designed to give finance teams oversight and workers a clearer view of payout status and timing.",
  },
];

const markStyle = {
  background: "linear-gradient(transparent 66%, #fbaf1be6 0)",
  padding: "0 0.08em",
  color: "inherit",
};

const PayFaqSection = () => {
  const [openIndex, setOpenIndex] = useState(0);

  return (
    <section className="bg-white py-16 lg:py-[105px] px-6 lg:px-8" id="faq">
      <div className="container mx-auto grid pay-grid-78-22 gap-10 lg:gap-[70px] items-start">
        <Animate.Fade bottom>
          <div>
            <p className="text-[#986500] tracking-[0.1em] uppercase text-[15px] font-black mb-4">
              Questions, Answered
            </p>
            <h2
              className="text-primary tracking-[-0.05em] leading-[1.06] font-black mb-6"
              style={{ fontSize: "clamp(38px, 4vw, 56px)" }}
            >
              Start with the people{" "}
              <mark style={markStyle}>you need to pay.</mark>
            </h2>
            <span className="text-[#5c6274] text-[18px] leading-[1.75] block mb-6">
              A Utiva specialist can review your countries, worker types and
              current payroll process with you.
            </span>
            <a
              href="https://app.utiva.co/signup?goal=workforce"
              target="_blank"
              rel="noreferrer noopener"
              className="text-primary inline-flex items-center gap-[14px] text-[16px] font-black hover:text-[#03046b] transition"
            >
              Ask about your team <span aria-hidden="true">↗</span>
            </a>
          </div>
        </Animate.Fade>

        <Animate.Fade bottom>
          <div className="border-t border-[#dce3f1]">
            {faqs.map((faq, index) => {
              const isOpen = index === openIndex;
              return (
                <div key={faq.question} className="border-b border-[#dce3f1]">
                  <button
                    type="button"
                    onClick={() => setOpenIndex(isOpen ? -1 : index)}
                    className="w-full flex items-center justify-between gap-5 text-left px-[3px] py-[23px] focus:outline-none"
                  >
                    <span className="text-primary text-[19px] font-black">
                      {faq.question}
                    </span>
                    <span
                      className={`text-secondary font-normal shrink-0 transition-transform ${
                        isOpen ? "rotate-45" : ""
                      }`}
                      style={{ fontSize: "27px", lineHeight: 1 }}
                    >
                      +
                    </span>
                  </button>
                  {isOpen && (
                    <p className="text-[#5c6274] text-[16px] leading-[1.75] m-0 px-[3px] pb-[23px]">
                      {faq.answer}
                    </p>
                  )}
                </div>
              );
            })}
          </div>
        </Animate.Fade>
      </div>
    </section>
  );
};

export default PayFaqSection;
